.container {
    width: calc(100% - 32px);
    padding-left: 16px;
    padding-right: 16px;
    border-bottom: 1px solid var(--off-white-dk);
    background-color: white;
}

.top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
}

.top-row-left-group {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px 8px;
}

/* Prevent filter button from shrinking */
.top-row-left-group > div:first-child {
    flex-shrink: 0;
}

/* Style button like text link */
.remove-filters {
    cursor: pointer;
    color: var(--blue);
}

.remove-filters:hover {
    text-decoration: underline;
    color: var(--blue-dk);
}

.top-row-right-group {
    flex-grow: 1;
}
